import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

// Decodificar JWT sin librería externa
function decodeJWT(token) {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const decoded = JSON.parse(atob(base64));
    if (!decoded?.id || !decoded?.rol) return null;
    return decoded;
  } catch { return null; }
}

function tokenExpirado(decoded) {
  if (!decoded?.exp) return false;
  return decoded.exp * 1000 < Date.now();
}

export function AuthProvider({ children }) {
  const [tecnico, setTecnico] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token  = localStorage.getItem('solvert_token');
    const stored = localStorage.getItem('solvert_tecnico');
    if (token && stored) {
      try {
        const decoded = decodeJWT(token);
        if (!decoded || tokenExpirado(decoded)) {
          // Token inválido o expirado — limpiar sesión sin esperar al 401
          localStorage.removeItem('solvert_token');
          localStorage.removeItem('solvert_tecnico');
          setLoading(false);
          return;
        }
        const storedData = JSON.parse(stored);
        storedData.rol = decoded.rol;
        setTecnico(storedData);
        localStorage.setItem('solvert_tecnico', JSON.stringify(storedData));
      } catch {}
    }
    setLoading(false);
  }, []);

  const login = (token, tecnicoData) => {
    // También extraer rol del JWT por si acaso
    const decoded = decodeJWT(token);
    if (decoded?.rol) tecnicoData.rol = decoded.rol;
    localStorage.setItem('solvert_token', token);
    localStorage.setItem('solvert_tecnico', JSON.stringify(tecnicoData));
    setTecnico(tecnicoData);
  };

  const logout = () => {
    localStorage.removeItem('solvert_token');
    localStorage.removeItem('solvert_tecnico');
    setTecnico(null);
  };

  return (
    <AuthContext.Provider value={{ tecnico, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
